module.exports = __webpack_public_path__ + "img/CS48Q-中_14.39de5d1f.jpg";